<script>
    import {VERSION} from "./lib/constants";
    import user from './stores/user';
    import {logout} from "./requests";
    import {Route, Link} from './router';
    import app_alert from "./stores/alerts";

    export let callback;
    export let collapsed = true;

    const signOut = () => {
        app_alert.show('confirm', "Θέλετε να αποσυνδεθείτε;",
            function () {
                logout();
                user.set({id: 0, session: null});
                window.location = "/app";
            });
    }
</script>

<aside>
    <div id="sidebar" class:collapsed={ collapsed }>
        <div class="sidebar-heading">
            <span on:click="{ callback }">ΜΕΝΟΥ <i class="fa fa-angle-right"></i></span>
        </div>
        <ul class="sidebar-menu">
            <li class="user-account">
                <div class="version">ΕΚΔΟΣΗ { VERSION }</div>
                <div class="user-icon"><i class="fa fa-user-circle"></i></div>
                <div class="user">{ $user.app_name }</div>
                <span class="signout" title="Αποσύνδεση" on:click="{ signOut }"><i class="fa fa-sign-out"></i></span>
            </li>
            <li on:click="{ callback }">
                <Link css_class="menu-item" href="/app">
                    <span class="icon"><i class="fa fa-comment"></i></span>
                    <span>Νέο Μήνυμα</span>
                </Link>
            </li>
            <li on:click="{ callback }">
                <Link css_class="menu-item" href="/app/messagespending" >
                    <span class="icon-group">
                        <i class="fa fa-comment-o"></i>
                        <i class="fa fa-long-arrow-right small"></i>
                    </span>
                    <span>Εξερχόμενα Μηνύματα</span>
                </Link>
            </li>
            <li on:click="{ callback }">
                <Link css_class="menu-item" href="/app/messagessent">
                    <span class="icon-group">
                        <i class="fa fa-comment-o"></i>
                        <i class="fa fa-check small"></i>
                    </span>
                    <span>Απεσταλμένα Μηνύματα</span>
                </Link>
            </li>
            {#if $user.is_admin}
            <li on:click="{ callback }">
                <Link css_class="menu-item" href="/app/clients">
                    <span class="icon"><i class="fa fa-users"></i></span>
                    <span>Πελάτες</span>
                </Link>
            </li>
            <li on:click="{ callback }">
                <Link css_class="menu-item" href="/app/credits_history">
                    <span class="icon"><i class="fa fa-history"></i></span>
                    <span>Ιστορικό Μονάδων</span>
                </Link>
            </li>
            {/if}
            <li on:click="{ callback }">
                <Link css_class="menu-item" href="/app/myaccount">
                    <span class="icon"><i class="fa fa-user-o"></i></span>
                    <span>Ο Λογαριασμός μου</span>
                </Link>
            </li>
        </ul>
    </div>
</aside>